// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"889b9358","455":"6a0c5f74","977":"b6867eb0"}[chunkId] + ".chunk.js";
};